import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import { withTranslation } from "react-i18next";
import { PofileColors } from "../../../../constants";
import tooltipImg from "assets/images/info_black-tooltip.svg";
import checkImg from "assets/images/check.svg";

const ProfileColorPicker = ({ t, selectedColor, onColorSelect, error }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <div className="c-field c-field-sm">
      <label>
        {t("accountOwner.profileColor")}
        <img
          src={tooltipImg}
          id="pick-color"
          alt="tooltip"
          className="ml-2"
        />
      </label>
      <Tooltip
        className="new-item-card-catalogue-tooltip"
        isOpen={tooltipOpen}
        placement="top"
        target="pick-color"
        toggle={() => setTooltipOpen(!tooltipOpen)}
      >
        {t("accountOwner.profileColorInfoMsg")}
      </Tooltip>
      <div className="profile_color_picker_container">
        {PofileColors.map((color, index) => (
          <div
            key={index}
            onClick={() => onColorSelect(color)}
            style={{ backgroundColor: color }}
            className="profile-color"
          >
            {selectedColor === color && (
              <img src={checkImg} width={20} height={20} alt="" />
            )}
          </div>
        ))}
      </div>
      {error && (
        <span className="error-msg mt-2">{error}</span>
      )}
    </div>
  );
};

export default withTranslation()(ProfileColorPicker);
